/**
 *
 * @module BaseMessage
 * @desc Base message object for messages/events coming out of the unified-player
 * @class BaseMessage
 *
 */
class BaseMessage {

    /**
     *
     * @param {string} type The message type
     * @param {Object} mediaPlayer A reference to the current player
     * @param {any} data A message to pass to
     *
     */
    constructor(type, mediaPlayer = null, data = null) {

        /**
         *
         * @type {string}
         *
         */
        this.type = type;

        /**
         *
         * @type {MediaPlayer}
         *
         */
        this.mediaPlayer = mediaPlayer;

        /**
         *
         * @type {MediaPlayer}
         *
         */
        this.data = data;

    }

}

export default BaseMessage;
